import React from 'react';
import { Row } from 'components/layout';
import {
  IconContainer,
  Label,
  QuestionIcon,
  CheckIcon,
  CloseIcon,
} from './style';
import { useTranslation } from 'i18n';
import { ucFirst } from 'utils/js';

export interface AnswerOptionLabelProps {
  type: ANSWER_TYPE;
}

export enum ANSWER_TYPE {
  YES = 'yes',
  NO = 'no',
  OPEN = 'open',
}

const defaultProps = {};

function AnswerOptionLabel(props: AnswerOptionLabelProps) {
  const { t } = useTranslation();

  const icon = React.useMemo(() => {
    switch (props.type) {
      case ANSWER_TYPE.YES:
        return <CheckIcon />;
      case ANSWER_TYPE.NO:
        return <CloseIcon />;
      case ANSWER_TYPE.OPEN:
        return <QuestionIcon />;
    }
  }, [props.type]);

  return (
    <Row {...props}>
      <IconContainer>{icon}</IconContainer>
      <Label>{t(ucFirst(props.type))}</Label>
    </Row>
  );
}

AnswerOptionLabel.defaultProps = defaultProps;

export default AnswerOptionLabel;
